/**
 * Performs a shallow comparison between two objects.
 * Returns true if the objects have the same keys and values at the top level.
 * Does not perform deep comparison of nested objects.
 *
 * @param objA - First object to compare
 * @param objB - Second object to compare
 * @returns true if objects are shallowly equal, false otherwise
 */
export function shallowEqual(objA: any, objB: any): boolean {
  // Check if references are the same
  if (objA === objB) {
    return true;
  }

  // Check if either is null or undefined
  if (objA == null || objB == null) {
    return objA === objB;
  }

  // Check if both are objects
  if (typeof objA !== 'object' || typeof objB !== 'object') {
    return objA === objB;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  // Check if they have the same number of keys
  if (keysA.length !== keysB.length) {
    return false;
  }

  // Check if all keys and values are the same
  for (let i = 0; i < keysA.length; i++) {
    const key = keysA[i];

    // Check if objB has the key and if values are equal
    if (!Object.prototype.hasOwnProperty.call(objB, key) || objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
}

export default shallowEqual;
